export const ACCOUNT_NOTIFICATION_SETTINGS_PATHS = {
    alert: (alertId: string) => `/settings/account/notifications/alerts/${encodeURIComponent(alertId)}`,
    alerts: '/settings/account/notifications/alerts',
    createAlert: '/settings/account/notifications/alerts/new',
    general: '/settings/account/notifications/general',
    root: '/settings/account/notifications',
} as const;
